
// ----------------------------------------------------------------------------------------------------
// The responsibility of this JavaScript file is to interact with the DOM directly and display a loading
// message if an initial SPA startup timeout is exceeded. If the SPA doesn't startup within another
// timeout then an error message is displayed.
// ----------------------------------------------------------------------------------------------------

// If the time from initial load of the Vue SPA is greater than timeout then show preloader
  setTimeout(function showPreloaderScreen() {
    'use strict';

    const preloaderElement = document.getElementById('preloaderScreen');
    const fatalErrorElement = document.getElementById('fatalErrorScreen');

    // Once Vue  is loaded, the element won't exist in the DOM so check for existance first
    if (preloaderElement) {
      preloaderElement.style.display = 'block';
    } else {
      // If the element wasn't in the DOM then the SPA loaded fine
      return;
    }

    // If a fatal error occurs with Vue loading and it never happens then display fatal error message
    setTimeout(function showFatalErrorScreen() {

      // Once Vue is loaded, the element won't exist in DOM so check for existance first
      if (preloaderElement) {
        preloaderElement.style.display = 'none';
      }

      if (fatalErrorElement) {
        fatalErrorElement.style.display = 'block';
      }

    }, 60 * 1000);

  }, 500);